module.exports = __webpack_public_path__ + "static/news4-2-956bd2b56c3d4d81802f6f7ef3628b27.jpg";